import type { Message } from './types';
import { useStore } from '@/store/store';

export const isSameOriginLobbyMessage = (message: Message): boolean =>
    typeof window !== 'undefined' && message.origin === window.location.origin;

export const isMessageFromEmbeddedIframe = (message: Message): boolean => {
    const { embeddedGame } = useStore.getState();

    return (
        embeddedGame.isOpen &&
        embeddedGame.iframeRef?.contentWindow !== null &&
        message.source === embeddedGame?.iframeRef?.contentWindow
    );
};
